var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.specializations.length
    ? _c(
        "section",
        {
          staticClass: "lpu-specializations",
          attrs: { "data-qa": "lpu_specializations" },
        },
        [
          _setup.isMobile
            ? _c(_setup.CoreSwiper, {
                staticClass: "mx-n2 px-2",
                attrs: {
                  "free-mode": "",
                  "slides-per-view": "auto",
                  "has-pagination": false,
                  "space-between": 16,
                  "placeholder-min-height": 220,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "slides",
                      fn: function ({ slideAttrs }) {
                        return _vm._l(
                          _vm.specializations,
                          function (item, index) {
                            return _c(
                              "div",
                              _vm._b(
                                { key: item.speciality.id },
                                "div",
                                slideAttrs,
                                false
                              ),
                              [
                                _c(_setup.SpecializationItem, {
                                  staticClass: "h-100",
                                  attrs: {
                                    "is-primary": index % 2 === 0,
                                    "lpu-doctors-url": _setup.lpuDoctorsUrl,
                                    specialization: item,
                                    "text-btn": _setup.goToBtnText,
                                  },
                                }),
                              ],
                              1
                            )
                          }
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  2567871321
                ),
              })
            : _c(
                "div",
                { staticClass: "lpu-specializations__list ga-4" },
                _vm._l(_vm.specializations, function (item, index) {
                  return _c(_setup.SpecializationItem, {
                    key: item.speciality.id,
                    attrs: {
                      "is-primary": index % 2 === 0,
                      "lpu-doctors-url": _setup.lpuDoctorsUrl,
                      specialization: item,
                      "text-btn": _setup.goToBtnText,
                    },
                  })
                }),
                1
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }